import useAppSelector from "hooks/useAppSelector";
import { FC } from "react";
import CartElementCheckout from "../CartElementCheckout";
import { formatCartElementDate } from "utils/dateTimeUtils";
import { getDayNr } from "utils/cartUtils";
import { useGetExcursionImages } from "modules/excursions/hooks/useGetExcursionImages";

type Props = {
  excursion: any;
};

const CartExcursionEntryCheckout: FC<Props> = (props) => {
  const excursion = props.excursion;
  const cruiseStartDate = useAppSelector(
    (state) => state.cruises.cruiseStartDate
  );

  const { getExcursionImageThumbnail } = useGetExcursionImages({
    excursionId: excursion?.excursionId,
  });

  return (
    <CartElementCheckout
      name={excursion.excursionName}
      isOldImageSolution={getExcursionImageThumbnail ? false : true}
      imageReference={getExcursionImageThumbnail}
      imageCategory="cruiseExcursion"
      linkTo={`/excursion/${excursion.itineraryId}/${excursion.excursionId}`}
      pricePreText="Excursion cost:"
      price={excursion.price}
    >
      <div className="uppercase">{excursion.portName}</div>
      <div>
        On day {getDayNr(excursion.date, cruiseStartDate)} (
        {formatCartElementDate(excursion.date)})
      </div>
      <ul className="list-reset mt-4 md:flex-grow">
        {excursion.passengers.map(
          (passenger: { firstName: any; lastName: any }, index: number) => (
            <li
              key={index}
            >{`${passenger.firstName} ${passenger.lastName}`}</li>
          )
        )}
      </ul>
    </CartElementCheckout>
  );
};

export default CartExcursionEntryCheckout;
